import { getRating } from '@/helpers/statusIncident.js';
import { supportRequests } from '@/helpers/dummyData';
import TicketItem from '@/components/request/elements/TicketItem/TicketItem.vue';
import CDatePicker from '@/components/global/CDatePicker.vue';
import { mapActions, mapState } from 'vuex';
import { showError, hasItems } from '@/helpers/globalHelpers';

export default {
	name: 'DeletedIncidentTab',
	data() {
		return {
			searchTextUser: '',
			debouncedSearchUser: null,

			isLoadingManagements: false,

			searchTextAssignedUser: '',
			debouncedSearchAssignedUser: null,
			loadingSearchAssignedUser: false,

			localSearchUsers: [],
			loadingSearchUser: false,

			loading: false,
			searchTimeout: null,
			searchValue: '',
			dialog: false,

			isLoadingAreas: false,
			isLoadingClassifications: false,

			statusList: [
				{ text: 'TODOS LOS ESTADOS', value: 'ALL' },
				{ text: 'SOLICITADO', value: 'SOLICITADO' },
				{ text: 'RESUELTO', value: 'RESUELTO' },
				{ text: 'EN ATENCIÓN', value: 'EN ATENCION' },
				{ text: 'CONSULTA', value: 'CONSULTA' },
				{ text: 'CONSULTA ADICIONAL', value: 'CONSULTA ADICIONAL'},
				{ text: 'CONSULTA EXTERNA', value: 'CONSULTA EXTERNA'},
				{ text: 'CERRADO', value: 'CERRADO' },
				{ text: 'CALIFICADO', value: 'CALIFICADO' },
				{ text: 'PENDIENTE AP', value: 'PENDIENTE AP' },
			],
			service: null,
			ticketLimits: [10, 20, 50, 80],
			ticketfilters: {
				page: 1,
				limit: 20 || process.env.VUE_APP_PAGINATION_PER_PAGE,
				pagination: true,
				num_ticket: null,
				status: [],
				attention_type: null,
				generic: false,
				responsible_id: null,
				assigned_user_id: null,
				area: null,
				classification_id: null,
				start_date: null,
				end_date: null,
			},
			supportRequests: supportRequests,
		};
	},

	created() {
		this.getTickets();
		this.getResponsibles();
		this.loadManagements();
		this.loadAreas();
		this.loadClassifications();
		this.debouncedSearchUser = this.debounce(this.fetchSearchUsers, 500);
		this.debouncedSearchAssignedUser = this.debounce(this.fetchSearchAssignedUsers, 500);
	},

	methods: {
		...mapActions('security', ['findUsers', 'getCostCenters']),
		...mapActions('user', ['getResponsibles']),
		...mapActions('ticket', ['listDeletedTicketForResponsibles', 'cleanDeletedTickets']),
		...mapActions('area', ['listAllAreas']),
		...mapActions('classification', ['listClassification']),

		getRating,
		hasItems,

		debounce(func, delay) {
			let timer;
			return function (...args) {
				clearTimeout(timer);
				timer = setTimeout(() => func.apply(this, args), delay);
			};
		},

		async fetchSearchUsers(query) {
			if (!query || query.length < 2) return;
			this.loadingSearchUser = true;
			try {
				const { ok, response } = await this.findUsers({
					active: true,
					search: query.toUpperCase(),
					searchType: 'select',
					pagination: false,
				});
				if (ok) {
					this.localSearchUsers = response.data.map((user) => ({
						...user,
						fullName: user.fullName?.toUpperCase() || '',
					}));
				}
			} catch (err) {
				console.error(err);
			} finally {
				this.loadingSearchUser = false;
			}
		},

		async fetchSearchAssignedUsers(query) {
			if (!query || query.length < 2) return;
			this.loadingSearchAssignedUser = true;

			try {
				const { ok, response } = await this.findUsers({
					active: true,
					search: query.toUpperCase(),
					searchType: 'select',
					pagination: false,
				});

				if (ok) {
					this.localSearchUsers = response.data.map(user => ({
						...user,
						fullName: user.fullName?.toUpperCase() || '',
					}));
				}
			} catch (err) {
				console.error(err);
			} finally {
				this.loadingSearchAssignedUser = false;
			}
		},

		loadManagements: async function () {
			this.isLoadingManagements = true;
			await this.getCostCenters();
			this.isLoadingManagements = false;
		},

		loadAreas: async function () {
			this.isLoadingAreas = true;
			await this.listAllAreas();
			this.isLoadingAreas = false;
		},

		loadClassifications: async function () {
			this.isLoadingClassifications = true;
			await this.listClassification();
			this.isLoadingClassifications = false;
		},

		searchTickets() {
			this.ticketfilters.page = 1;
			this.getTickets();
		},

		async getTickets() {
			this.loading = true;

			const filters = { ...this.ticketfilters };

			if (filters.status?.includes('ALL')) {
				filters.status = null;
			} else if (Array.isArray(filters.status)) {
				filters.status = filters.status.join(',');
			}

			const { error } = await this.listDeletedTicketForResponsibles(filters);
			if (error) showError(error);
			this.loading = false;
		},

		debounceSearch() {
			clearTimeout(this.searchTimeout);
			this.searchTimeout = setTimeout(() => {
				this.ticketfilters.num_ticket = this.searchValue;
				this.getTickets();
			}, 800);
		},
	},

	beforeDestroy() {
		this.cleanDeletedTickets();
	},
	destroyed() {
		clearTimeout(this.searchTimeout);
	},

	components: {
		TicketItem,
		CDatePicker,
	},

	computed: {
		...mapState('ticket', [
			'deletedTickets',
			'deletedTicketsPagination',
		]),

		...mapState('security', [
			'costCenters',
		]),

		...mapState('auth', ['user']),

		...mapState('area', ['allAreas']),
		...mapState('classification', ['classifications']),

		filteredTickets() {
			if (!this.service) return this.deletedTickets;

			const text = this.service.toLowerCase();
			return this.deletedTickets.filter(ticket =>
				ticket.assigned_user.service?.toLowerCase().includes(text)
			);
		},
	},

	watch: {
		user: {
			handler(newVal) {
				if (newVal?.id && !this.ticketfilters.responsible_id) {
					this.ticketfilters.responsible_id = newVal.id;

					const yaExiste = this.localSearchUsers.some(u => u.id === newVal.id);
					if (!yaExiste) {
						this.localSearchUsers.unshift({
							...newVal,
							fullName: newVal.fullName?.toUpperCase() || `${newVal.name} ${newVal.last_name_father}`.toUpperCase()
						});
					}
				}
			},
			immediate: true,
		},
	},
};
